<template>
	<form class="form-ativo" :class="{external: !isMobile && external}" action="#" @submit.prevent="ativoSelecionado" data-vv-scope="formulario">
		<div>
			<div class="form-group">
				<label class="form-label" for="ativo">Tipo de investimento</label>
				<div class="multiselect-group" :title="tipoAtivo ? tipoAtivo.descricao : ''">
					<multiselect v-model="tipoAtivo" :options="tiposAtivos"
						placeholder="Selecione"
						track-by="codigo" label="descricao" :show-labels="false"
						class="form-control m-0 p-0"/>
				</div>
			</div>
			<div class="form-group">
				<label class="form-label" for="ativo">Escolha um ativo</label>
				<div class="multiselect-group">
					<multiselect v-model="campoBuscarAtivo.value" :options="campoBuscarAtivo.options"
						:searchable="true" :internalSearch="false" :show-labels="false"
						class="form-control m-0 p-0" :class="{'is-invalid': errors.has('formulario.ativo'), dark: dark}"
						v-validate="'required'" name="ativo" key="ativo"
						placeholder="Nome ou CNPJ do ativo" track-by="key" label="value"
						:loading="campoBuscarAtivo.isLoading"
						@search-change="listarAtivos"
						@close="campoBuscarAtivo.isOpen = false">
						<template slot="noResult">Nenhum ativo foi encontrado. Verifique o termo buscado e tente novamente</template>
						<template slot="noOptions">Digite para começar a buscar</template>
						<template slot="option" slot-scope="props">
							<p class="option__desc">{{ props.option.value }}</p>
						</template>
						<p slot="singleLabel" slot-scope="item">{{item.option.value}}</p>
					</multiselect>
					<div v-if="campoBuscarAtivo.value" class="multiselect-close" @click="campoBuscarAtivo.value = null">
						<img src="img/icons/ico-close.svg" alt="">
					</div>
				</div>
			</div>
	        <button class="btn btn-submit" type="submit" :disabled="!campoBuscarAtivo.value">+ Adicionar e comparar</button>
		</div>
        <div class="form-indexadores form-group">
            <label class="form-label no-change">Indexadores</label>
            <div class="checkbox-group">
                <div v-for="(indexador, index) in indexadores" class="checkbox c-checkbox" :key="index">
                    <label>
                        <input type="checkbox" :value="indexador" v-model="indexadoresSelecionados" :disabled="indexadoresSelecionados.length == 1 && indexadoresSelecionados[0] == indexador"/>
                        <span class="fa fa-check"></span>{{indexador.nomeIndexador}}
                    </label>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import Multiselect from "vue-multiselect"

import ModalAtivoNaoEncontrado from "@/app/components/Desktop/Modals/ModalAtivoNaoEncontrado"
import ComparadorService from "@/app/services/Comparador/comparador.service"

export default {
	components: {
		Multiselect,
		ModalAtivoNaoEncontrado,
	},
	props: ["codigoTipoAtivo"],
	data() {
		return {
			tiposAtivos: [],
			tipoAtivo: null,
            indexadoresSelecionados: [],
			campoBuscarAtivo: {
				isOpen: false,
				value: null,
				options: [],
				isLoading: false,
			},
            timeout: null,
		}
	},
	computed: {
		dark() {
			return this.$route.query.dark
		},
        indexadores() {
            return this.$store.getters.getIndexadores
        },
		external() {
			return this.$route.query.external
		},
		isMobile() {
            return this.$mq == 'mobile'
        },
	},
    watch: {
        indexadoresSelecionados(val) {
            clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				if (val.length == 0) {
					this.indexadoresSelecionados.push(this.indexadores.find(el => el.id == 1))
				} else {
					this.$store.commit("setSelecionados", val.map(el => el.codigoIndexador))
				}
			}, 800)
        },
		tipoAtivo() {
			this.campoBuscarAtivo.options = []
		}
    },
	methods: {
		listarAtivos(query) {
			if (query == "" || query == null) return // Evitar requisição com query vazia

			let select = this.campoBuscarAtivo
			select.isLoading = true

			// Tratativa para iniciar a busca algum tempo após o usuário parar de digitar
			clearInterval(this.typingTimeout)

			this.typingTimeout = setTimeout(() => {
				// TODO: usar o tipoAtivo e descobrir qual id é qual
				let codigoTipoInvestimento = this.tipoAtivo?.codigo

				ComparadorService.buscarAtivos(query, codigoTipoInvestimento).then(
					(resposta) => {
						if (resposta.sucesso && resposta.ativos) {
							select.options = []

							for (let i = 0; i < resposta.ativos.length; i++) {
								const ativo = resposta.ativos[i]
								select.options.push({ key: ativo.codigo, value: ativo.nome })
							}
						}
						select.isLoading = false
					}
				)
			}, 350)
		},
		ativoSelecionado() {
			this.$emit("acaoRealizada", { tipo: "novoAtivoSalvo", ativo: this.campoBuscarAtivo.value })
			this.campoBuscarAtivo.value = null
			this.campoBuscarAtivo.options = []
		},
	},
	beforeMount() {
		if (this.tiposAtivos.length <= 0) {
			ComparadorService.obterTiposAtivos().then((retorno) => {
				if (retorno.sucesso) {
					this.tiposAtivos = retorno.tipos
					this.tiposAtivos.find(e => e.codigo == 0).descricao = 'Todos'
					this.tipoAtivo = this.tiposAtivos.find(() => true)
				}
			})
		}
        this.indexadoresSelecionados = this.$store.getters.getSelecionados
	},
}
</script>

<style lang="scss">
form.form-ativo.external {
    display: flex;
    flex-direction: column;
	> div:first-child {
		display: flex;
		flex-direction: row;
		align-items: center;
		> div {
			flex: 1;
			margin: 30px 24px;
		}
		> button {
			margin: 30px 24px 0;
			flex: 1;
			max-width: 300px;
			height: 40px;
			border-radius: 4px;
			&:not(:disabled) {
				color: #fff;
				background-color: $main-color;
				border-color: $main-color;
			}
		}
	}
	.form-indexadores {
		margin: 12px 24px 0;
		.checkbox-group {
			display: flex;
			flex-direction: row;
			.c-checkbox {
				margin-right: 32px;
				label {
					margin-bottom: 0;
				}
			}
		}
	}
	.multiselect__element p, .multiselect__single p {
		margin-bottom: 0;
	}
	.multiselect__select {
		display: none;
	}
	/*
	+--------------------------+
	|                          |
	|       Multiselect        |
	|                          |
	+--------------------------+
	*/
	.multiselect__tags, .multiselect__content {
		background-color: transparent !important;
		color: $text-font-color !important;
	}

	.multiselect__tags, .multiselect__option {
		border-color: $box-border-color !important;
	}

	.multiselect__content-wrapper {
		border-color: $box-border-color;
	}
	.multiselect__content-wrapper {
		background-color: $box-bg;
	}
	.multiselect__single {
		background-color: transparent !important;
		color: $text-font-color;
	}

	.multiselect__option--selected {
		background-color: transparent;
		color: $main-color-alt !important;
	}

	.multiselect__input {
		background-color: transparent !important;
		color: $text-font-color !important;
	}

	.multiselect__input::placeholder {
		color: $disabled-font-color;
	}
	.multiselect__option.multiselect__option--group {
		background: $sidebar-bg !important;
		color: $sidebar-font-color !important;
	}

	.multiselect__content .multiselect__option.multiselect__option--highlight.multiselect__option--selected {
		background: transparent !important;
	}
	.multiselect--disabled {
		background: transparent !important;
	}
	.multiselect.form-control {
		background: transparent !important;
	}

}
.form-indexadores {
	margin-top: 16px;
}
.multiselect-group {
	position: relative;
}
.multiselect-close {
	position: absolute;
	width: 24px;
	height: 38px;
	right: 0;
	top: 1px;
	padding: 6px 8px 6px 8px;
	text-align: center;
	cursor: pointer;
}
.cabecalho {
	.multiselect__select {
		display: none;
	}

	.multiselect__tags {
		border-right: none !important;
		border-top-right-radius: 0 !important;
		border-bottom-right-radius: 0 !important;
	}

	.dark .multiselect__tags {
		color: $text-font-color;
		background-color: $default-bg !important;
	}

	.dark .multiselect__content-wrapper {
		color: $text-font-color;
		background-color: $default-bg !important;
	}

	.dark .multiselect__placeholder {
		color: $text-font-color;
		background-color: $default-bg !important;
	}

	.dark .multiselect__input {
		color: $text-font-color;
		background-color: $default-bg !important;
		border-color: $main-color;
	}

	.dark input-group-append {
		background-color: $default-bg !important;
	}

	.input-group-append section {
		border-left: none !important;
		border-radius: 8px;
		border-top-left-radius: 0;
		border: 1px solid #bdbdbd;
		background-color: white;
		cursor: pointer;
	}

	.input-group-append-dark section {
		// border-left: none !important;
		border-radius: 8px;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		border: 2px solid $main-color;
		background-color: $default-bg;
		cursor: pointer;
	}

	.input-group-append.multiselect-focused section {
		border-color: $main-color;
		border-width: 2px;
		padding-bottom: 7px; // Fica um desalinhamento estranho se não tiver

		i {
			color: $main-color;
		}
	}

	.dark .form-group {
		border: 2px solid $main-color;
	}

	.ativo-nao-encontrado {
		padding: 0px;
		color: $default-bg !important;
		font-size: 12px;
		text-decoration: underline;
	}

	.ativo-nao-encontrado-dark {
		padding: 0px;
		color: $main-color !important;
		font-size: 12px;
		text-decoration: underline;
	}

	.fa-search {
		color: $main-color;
	}
}

.form-ativo:not(.external) {
	.multiselect-close {
		background: $sidebar-bg;
	}
	.form-group {
		margin-bottom: 32px;

		&.relative { position: relative; }

		label {
			color: #BDBDBD !important;
			font-size: 14px;
			line-height: 20px;
			margin-bottom: 16px;

			&.no-change { font-weight: normal !important; }
		}

		.multiselect-group {
			position: relative;

			.multiselect:not(.borderless-multiselect) {
				.multiselect__select {
					padding: 12px 0 8px;
					width: 12px;

					&::before {
						border-color: $main-color transparent transparent;
						color: $main-color;
					}
				}

				.multiselect__tags {
					border-top: none !important;
					border-left: none !important;
					border-right: none !important;
					border-radius: 0;
					border-color: rgba(36, 36, 36, 0.35);
					padding: 9px 0 0 !important;

					.multiselect__spinner {
						margin-right: 12px;
					}

					.multiselect__input {
						padding: 0;
						margin-bottom: 0;

						&::placeholder {
							color: #BDBDBD;
						}
					}

					.multiselect__single {
						padding-left: 0;
						background: transparent;
						// max-width: 90%;
						> p {
							margin-bottom: 0;
							max-width: 90%;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}
				}

				.multiselect__tags, .multiselect__tags > .multiselect__placeholder, .multiselect__input {
					font-size: 16px;
				}

				.multiselect__content-wrapper {
					min-width: 100%;
					overflow-x: hidden;
					background: $sidebar-bg;
					border-color: $sidebar-bg;

					.multiselect__content {
						max-width: 100%;

						.multiselect__element {
							min-width: 100%;
							width: fit-content;

							.multiselect__option {
								background: transparent !important;

								&.multiselect__option--selected p { opacity: 1; }

								p {
									margin-bottom: 0;
									width: calc(100% - 1px);
									white-space: nowrap;
									text-overflow: ellipsis;
									overflow: hidden;
									color: $alt-bg;
									opacity: .6;
								}
							}

							&:hover {
								p {
									opacity: 1;
								}
							}
						}
					}
				}
			}
		}

		.form-control, .multiselect__tags {
			border-color: #868686 !important;

			&, .multiselect__input {
				background: transparent;
				color: white;
			}
		}

		input.form-control {
			border-top: none !important;
			border-left: none !important;
			border-right: none !important;
			border-radius: 0 !important;
			padding-left: 0;
			box-shadow: none;
			border-color: rgba(36, 36, 36, 0.35);
		}

		.checkbox-group {
			display: flex;
			flex-wrap: wrap;
			border-bottom: 1px solid rgba(36, 36, 36, 0.1);

			.checkbox {
				flex: 40%;
				margin-left: 0;
				margin-right: 14px;
				> label {
					display: flex;
					align-items: center;
					color: $alt-bg !important;

					input:checked + span {
						background-color: $main-color;
						border-color: $main-color;

						&::before {
							color: white;
						}
					}

					span {
						height: 12px;
						width: 12px;
						margin-right: 10px;
						border-color: $alt-bg;

						&::before {
							font-size: 8px;
							line-height: 10px;
						}
					}
				}
			}
		}
	}

	.btn-submit {
		width: 100%;
		background: $main-color-alt;
		border: none;
		border-radius: 50px;
		padding: 10px;
		color: white !important;
		opacity: 1;
		font-size: 14px;
		font-weight: normal;
		transition: background 0s;

		&:disabled { background: #E8E8E8 !important; color: $sidebar-bg !important; }
		&:hover {
			background: $main-color;
		}
		&:focus { transition: background .8s; }

		&:active {
			background-color: $main-color-alt;
			background-size: 100%;
			transition: background 0s;
		}
	}
}

.pikaday-container .pika-single {
	width: 100%;
	.pika-lendar {
		.pika-title {
			padding: 6px 12px 3px;
			background: transparent;
			font-weight: 600;
			color: $text-font-color;
			display: block;

			.pika-label {
				background: transparent;
				font-size: 14px;
				font-weight: bold;
			}

			// .pika-select { height: 10px; }

			.pika-prev, .pika-next {
				margin-top: 7px;
				width: 8px;
				&:not(.is-disabled) { opacity: 1; }
			}
			.pika-prev:before {
				content: '>';
			}
			.pika-next:before {
				content: '<';
			}
		}

		.pika-table td button:hover {
			background: $main-color-alt;
		}
	}
}
</style>